<template>
<transition name="Right">
  <div class="withdraw">
    <Header :color="'white'" :fontColor="'black'">
      <span slot="center">余额提现</span>
      <span slot="right" @click="toRecord(2)">提现记录</span>
    </Header>   
    <div class="bar" v-if="alipaycode!==''">
      <img src="@/assets/个人中心/ali.png" alt="">
      <span>到账支付宝账号：{{alipaycode}}</span>
    </div>
    <div class="bar" v-else @click="dialog = true">
      <img src="@/assets/个人中心/ali.png" alt="">
      <span>点此绑定支付宝</span>
    </div>
    <div class="bar">
      <van-field v-model="money"  placeholder="请输入要提现金额" type="number" />
      
    </div>
    <div class="tips">
    当前可提现 {{balance}} 元
    </div>
    <button class="w_btn" 
    @click="withdraw" :disabled="money==''||money*1>balance||balance===0||money*1==0||money*1<1" :class="{disable:money==''||money*1>balance||balance===0||money*1==0||money*1<1}">
      确认提现
    </button>
    <div class="tips">
      温馨提示
      <div>
        <div style="margin-bottom:10px;text-indent:10px">各位亲们，每月25~31日为提现日哦！记得哦！提现结算金额为上月已确认收货订单佣金！</div>
        <p style="margin-bottom:10px;color:rgb(50,50,50);font-size:14px;text-indent:10px">备注：注意预估收入与结算收入数据会不同，不是钱少了！而是预估收入是上月所有下单的佣金，结算收入是上月所有已经确认收货的订单佣金！</p>
		    <!-- <p>提现日为每个月25-31日（月份最后一天）</p> -->
      </div>
    </div>
    <div class="add_ali" v-if="addAli">
    <Header :color="'white'" :fontColor="'black'">
      <span slot="left"><van-icon name="arrow-left" @click="addAli = false" /></span>
      <span slot="center">添加支付宝</span>
    </Header>  
      <van-form @submit="onSubmit">

          <van-field v-model="postData.realName" label="姓名" placeholder="请输入姓名"  :rules="[{ required: true, message: '请填写姓名' }]" />
          <van-field v-model="postData.aliPayCode" label="账号" placeholder="请输入账号" :rules="[{ required: true, message: '请填写账号' }]" />
          <van-field v-model="postData.phone" label="手机号" placeholder="请输入手机号" @input="input"
          
          :rules="[{ required: true, message: '手机号码格式错误',validator:phoneValidator }]"  />
          <div  style="position:relative;">
            <van-field v-model="postData.verifyCode" label="验证码" placeholder="请输入验证码" :rules="[{ required: true, message: '验证码格式错误',validator: securityCodeValidator, }]" />
            <div class="securityCode" :style="{ background: bgcolor,color:color }" @click="getSecurityCode">{{ captch_status }}</div>
          </div>
  
      <button class="submit_btn" type="submit">确认添加</button>  
      </van-form>
    </div>
    <div class="dialogBg" v-if="dialog">

      <div class="dialog">
        <!-- <img src="@/assets/个人中心/ali.png" alt=""> -->
        还没有添加支付宝账户
        <div class="btn">
          <div class="confirm" @click="dialog=false,addAli = true">前往添加</div>
          <div class="cancel" @click="dialog =false">取消</div> 
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
import Header from "@/components/Header/index";
import { applyCash } from "@/api/userBalance";
import { bindAliPay,getBindAliPayVerifyCode } from "@/api/ownCenter";
export default {
  name:'Withdraw',
  components:{
    Header
  },
  data(){
    return{
      money:'',
      addAli: false,
      disabled:false,
      dialog:false,
      postData: {
        realName: '',
        phone: '',
        aliPayCode: '',
        verifyCode: '',
        userId:''
      },
      captch_status: '获取验证码',
      bgcolor: 'rgba(174,179,192,0.25)',
      color: 'rgba(174,179,192,1)'
    }
  },
  computed:{
    balance(){
      return this.$store.state.userData.balance
    },
    alipaycode(){
      return this.$store.state.userData.aliPayCode?this.$store.state.userData.aliPayCode:''
    }
  },
  created(){
    this.postData.userId = this.$store.state.userId
  },
  methods:{
    withdraw(){
      if(this.money==''||this.money*1>this.balance){
          this.$toast.fail({
          duration: 1200,
          message: '提现金额已超出余额！'
        })
        return
      }
      var re = /^[0-9]+.?[0-9]*$/;
      if (!re.test(this.money)) {
        this.$toast.fail({
              duration: 1200,
              message: '请输入正确金额噢！'
        })
        return 
      }
      if(this.money*1 < 1){
        this.$toast.fail({
          duration: 1200,
          message: '最低提现金额1元！'
        })  
      return
      }
      applyCash({
        cashAmount: this.money*1,
        userId: this.$store.state.userId
      }).then(res=>{
        if(res.code === 2008){
          this.dialog = true
          return
        }else if(res.code == 1000){
          // this.$toast.success('提现成功');
          this.$toast.success({
            duration: 1200,
            message: '提现成功',
            forbidClick: true,
          });          
          setTimeout(()=>{
            this.money = ''
            this.$router.push('/')
          },1200)           
        }else{
          this.$toast.fail(res.msg);
        }
       
      })
    },
    onSubmit(){//添加支付宝
      // for(let i in this.postData){
      //   if(this.postData[i]===''){
      //     return false
      //   }
      // }
      this.postData.userId = this.$store.state.userId
      bindAliPay(this.postData).then(res=>{
        if(res.code == 1000){
          this.$toast.success('成功添加');
          this.$store.dispatch('asyncUpdateUserInfo',{userId:this.$store.state.userId}); 
          setTimeout(()=>{
            this.addAli = false
          },800)
        }else{
          this.$toast.fail(res.msg);
        }

        
      })
    },
    // 获取验证码
    getSecurityCode() {
      if (this.postData.phone.length === 11  && this.captch_status.indexOf('s') == -1) {
        getBindAliPayVerifyCode({
          phone:this.postData.phone,
          userId:this.$store.state.userId,
        })
        this.bgcolor = 'rgba(174,179,192,0.25)'
        this.color = 'black'
        let time = 60
        this.captch_status = 60 + 's'
        const timer = setInterval(() => {
          time -= 1
          this.captch_status = time + 's'
          if (time === 0) {
            this.captch_status = '重新获取'
            this.bgcolor = 'rgba(244,30,2,0.8)'
            this.color = 'white'
            clearInterval(timer)
          }
        }, 1000)
      }
    },
    // 检验函数
    phoneValidator(val) {
      return /^1\d{10}$/.test(val)
    },
    securityCodeValidator(val) {
      return val.length === 4
    },
    input() {
      if (this.postData.phone.length === 11 && /^1\d{10}$/.test(this.postData.phone) && this.captch_status.indexOf('s') == -1) {
        this.bgcolor = 'rgba(244,30,2,0.8)'
        this.color = 'white'
      } else {
        this.bgcolor = 'rgba(174,179,192,0.25)'
        this.color = 'rgba(174,179,192,1)'
      }
    },
    // nameValidator(val) {
    //   return val.length < 11
    // },
    toRecord(page){
      this.$router.push('/record?page='+page)
    },
  }
}
</script>

<style lang="less" scoped>
/deep/ .van-field__label{
  width:9rem;
  font-size: 1.4rem;
}
/deep/ .van-field__value{
  font-size: 1.4rem;
}
/deep/ .van-cell{
  padding: 1rem 1.6rem;
}
/deep/ .van-toast{
  width: 50vw !important;
}
.disable{
  background-color: rgba(180, 180, 180, .7) !important;
  color: rgba(80, 80, 80, 0.9) !important;

}
.dialogBg{
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,.6);
  width: 100vw;
  height: 100vh;
  z-index: 2;
  .dialog{
    position: absolute;
    width: 90vw;
    height: 12rem;
    top: 28rem;
    left: 5vw;
    z-index: 3;
    background-color: #fff;
    text-align: center;
    // line-height: 10rem;
    font-size: 1.6rem;
    border-radius: 6px;
    padding: 3rem;
    box-sizing: border-box;
    // display: flex;
    // align-items: center;
    color: rgb(100, 100, 100);
    .btn{
      display: flex;
      justify-content: space-around;
      line-height: 2.6rem;
      margin-top: 2rem;
      color: white;
      .confirm{
        width: 10rem;
        height: 2.6rem;
        background-color: #F63A25;
        border-radius: 4px;
      }
      .cancel{
        width: 10rem;
        height: 2.6rem;
        background-color:rgb(190, 190, 190);
        border-radius: 4px;
      }
    }
    a{
      color: #00BFFF;
      text-decoration: underline;
    }

  }
}

.withdraw{
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  .bar{
    margin-top: 8vw;
    width: 94vw;
    height: 5rem;
    background-color: #fff;
    margin-left: 3vw;
    border: 1px rgba(240, 240, 240, 0.8) solid;
    line-height: 1rem;
    display: flex;
    align-items: center;
    img{
      margin: 1rem 1.4rem;
      width: 3rem;
      height: 3rem;
    }
    span{
      color: grey;
      font-size: 1.4rem;
      opacity: .6;
    }
  }
  .tips{
    width: 90vw;
    font-size: 1.6rem;
    margin: 6vw auto;
    letter-spacing: 1px;
    line-height: 20px;
    // margin-top: 6vw;
    div{
      margin-top: 2.6rem;
    }
  }
  .w_btn{
    width: 92vw;
    border-radius: 50px;
    margin-left: 4vw;
    height: 5rem;
    font-size: 1.6rem;
    background-color: #F63A25;
    color: white;
    margin-top: 6vw;
    text-align: center;
    line-height: 5rem;
    border: 0;
    
  }

}
.add_ali{
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #fff;
    .securityCode{
      position: absolute;
      z-index: 99;
      right: 1.6rem;
      top: 1rem;
      width:8.5rem;
      height:2.5rem;

      border-radius:5px;
      font-size: 1.4rem;
      line-height: 2.5rem;
      text-align: center;
    }  
}
.submit_btn{
  width: 90vw;
  margin-left: 5vw;
  background-color:#F63A25;
  height: 4rem;
  text-align: center;
  line-height: 3rem;
  font-size: 1.6rem;
  color: white;
  margin-top: 1.6rem;
  position: absolute;
  bottom: 8rem;
  opacity: .8;
  border: 0;
  border-radius: 20px;
}
</style>